import React, { Fragment, useEffect, useRef, useState } from "react";
import {
  ProductItem,
  ProductList,
  ProductListWrapper,
  SearchInput,
  SearchWrap,
} from "./styles";
import {
  CloseButton,
  Modal,
  ModalBackdrop,
  ModalContent,
  ModalDialog,
  ModalTitle,
  ModalBody
} from "../Modal";
import CloseIcon from "../Icons/CloseIcon";
import SearchIcon from "../Icons/SearchIcon";
import { useSearch } from "../../useSearch";

const ProductSelectorModal = ({ isVisible, onSelect, onToggle }) => {
  const [search, setSearch] = useState("");
  const inputRef = useRef(null);
  const { results: filteredProducts } = useSearch(search, "products");

  useEffect(() => {
    if (isVisible) {
      inputRef.current.focus();
      document.body.style.overflow = 'hidden';
    } else {
      setSearch("");
      document.body.style.overflow = 'auto';
    }
  }, [isVisible]);

  return (
    <Fragment>
      <Modal
        className={"modal fade " + (isVisible ? "show" : "")}
        style={{ display: isVisible ? "block" : "none" }}
      >
        <ModalDialog className="modal-dialog modal-dialog-centered">
          <ModalContent className="modal-content">
            <ModalBody>
              <ModalTitle className="modal-title">Add Your Building</ModalTitle>
              <CloseButton className="close product-select-cancel" onClick={onToggle}><CloseIcon /></CloseButton>
              <SearchWrap>
                <SearchInput className="search">
                  <div className="input-icon right">
                    <input
                      ref={inputRef}
                      className="form-control"
                      type="text"
                      value={search}
                      placeholder="Type your keywords..."
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <span className="icon">
                      <SearchIcon />
                    </span>
                  </div>
                </SearchInput>
              </SearchWrap>
              <ProductListWrapper>
                <ProductList>
                  {filteredProducts.map((p, i) => (
                    <ProductItem
                      key={i}
                      onClick={() => {
                        onSelect(p);
                        setSearch("");
                      }}
                    >
                      <span>{p.title}</span>
                    </ProductItem>
                  ))}
                </ProductList>
              </ProductListWrapper>
            </ModalBody>
          </ModalContent>
        </ModalDialog>
      </Modal>
      {isVisible && (
        <ModalBackdrop className={"fade " + (isVisible ? "show" : "")} />
      )}
    </Fragment>
  );
};

export default ProductSelectorModal;
